import { useAppDispatch, useAppSelector } from "features/config/hooks";
import { FormEvent, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import {
  LoginHubLinkState,
  loginHubLink,
  resetLoginHubLinkState,
  selectLoginHubLink,
} from "../slices/tei-hub-link-login.slice";
import {
  TeiHubLinkSessionState,
  selectTeiHubLinkSession,
  teiHubLinkSession,
} from "../slices/tei-hub-link-session.slice";
import { resetTeiHubLinkOrders } from "../slices/tei-hub-link-orders.slice";
import { resetTeiHubLinkSoa } from "../slices/tei-hub-link-soa.slice";

export function TeiHubLinkLogin() {
  const dispatch = useAppDispatch();
  const loginHubLinkState = useAppSelector(selectLoginHubLink);
  const getHubLinkSessionState = useAppSelector(selectTeiHubLinkSession);

  const [identity, setIdentity] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [seePassword, setSeePassword] = useState(false);

  useEffect(() => {
    if (loginHubLinkState.status === LoginHubLinkState.success) {
      dispatch(teiHubLinkSession());
    }
  }, [loginHubLinkState, dispatch]);

  useEffect(() => {
    dispatch(teiHubLinkSession());
    dispatch(resetLoginHubLinkState());
  }, [dispatch]);

  const handleOnSubmit = (e: FormEvent<HTMLFormElement>) => {
    dispatch(resetTeiHubLinkOrders());

    dispatch(
      loginHubLink({
        identity,
        password,
      })
    );
    e.preventDefault();
  };

  if (
    getHubLinkSessionState.data &&
    getHubLinkSessionState.status === TeiHubLinkSessionState.success
  ) {
    const clientType =
      getHubLinkSessionState.data.hublink.clientType[1]?.name.toLowerCase();
    return <Navigate to={`/hublink/${clientType}`} />;
  }

  return (
    <>
      <div className="h-screen bg-white flex flex-col space-y-10 justify-center items-center">
        <div className="bg-white w-96 shadow-xl rounded p-5">
          <h1 className="text-3xl font-medium">Tei Hub Ordering</h1>
          {loginHubLinkState.message ? (
            <span
              className="text-sm"
              dangerouslySetInnerHTML={{
                __html: loginHubLinkState.message,
              }}
            />
          ) : (
            <p className="text-sm mt-1">
              Please login with your email/username and password below.
            </p>
          )}
          <form className="space-y-5 mt-5" onSubmit={handleOnSubmit}>
            <input
              type="text"
              className="w-full h-12 border border-gray-800 rounded px-3"
              placeholder="E-mail"
              value={identity}
              onChange={(e) => {
                setIdentity(e.target.value);
              }}
            />
            <div className="w-full flex items-center  border border-gray-800 rounded ">
              <input
                type={seePassword ? "text" : "password"}
                className="w-4/5 h-12 px-3"
                placeholder="Password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
              {seePassword ? (
                <FaEye
                  onClick={() => {
                    setSeePassword(false);
                  }}
                  className="text-lg cursor-pointer ml-[25px]"
                />
              ) : (
                <FaEyeSlash
                  onClick={() => {
                    setSeePassword(true);
                  }}
                  className="text-lg cursor-pointer ml-[25px]"
                />
              )}
            </div>

            {/* <div className="">
              <a
                href="#!"
                className="font-medium text-primary hover:text-red-500 rounded-full p-2"
              >
                Forget password ?
              </a>
            </div> */}

            <button
              type="submit"
              className="text-center w-full bg-primary rounded-full text-white py-3 font-medium"
            >
              Login
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
